import { categoryLabel, inCategory, NO_CATEGORY, NO_CATEGORY_LABEL } from "../../shared/categories";

// The Goals page's category filter (Craig, 29 Oct 2026: "I want to be able to filter the view I'm looking at by
// Category"). The choices are the user's categories, in their order, that have an active goal, then "No category"
// when a goal has none (or one since deleted). `ALL` shows every goal.
export const ALL = "all";

export const categoryChoices = (activeGoals, categories) => {
  const goals = activeGoals || [];
  const used = (categories || []).filter(c => goals.some(g => g.categoryId === c.id));
  const someWithout = goals.some(g => inCategory(g, NO_CATEGORY, categories));
  return [
    ...used.map(c => ({ id: c.id, label: categoryLabel(c) })),
    ...(someWithout ? [{ id: NO_CATEGORY, label: NO_CATEGORY_LABEL }] : []),
  ];
};

// Whether a goal (or a task, by its own categoryId) shows with `choice` chosen.
export const inChosenCategory = (item, choice, categories) => choice === ALL || inCategory(item, choice, categories);
